<div
  [style]="{
    '--proffeo-ui-tiptap-editor-min-height': minHeight(),
    '--proffeo-ui-tiptap-editor-max-height': maxHeight()
  }"
  class="proffeo-ui-tiptap-editor-surface"
>
  <tiptap-editor
    [editor]="editor"
    class="tiptap-editor-content prose prose-headings:mt-0 prose-headings:mb-0 prose-p:mt-0"
  ></tiptap-editor>

  @if (showMenu()) {
    <proffeo-editor-text-menu [editor]="editor" />
    <proffeo-editor-custom-node-menu [editor]="editor" />
    <proffeo-editor-new-block-menu [editor]="editor" />
    <proffeo-table-column-menu [editor]="editor" />
    <proffeo-table-row-menu [editor]="editor" />
  }
</div>

@if (showCounter()) {
  <p
    [class.proffeo-ui-tiptap-editor-counter--exceeded]="counterExceeded()"
    class="proffeo-ui-tiptap-editor-counter"
  >
    {{ plainTextLength() }} / {{ maxLength() }}
  </p>
}

@if (showErrorMessage()) {
  <p class="proffeo-ui-tiptap-editor-error">{{ errorText() | translate }}</p>
}
